var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShieldOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M4.627 8.24 15.6 2.154a1.222 1.222 0 0 1 1.185 0L27.76 8.241c.387.214.627.62.627 1.062 0 .845-.139 20.697-12.194 20.697-.753 0-1.46-.078-2.123-.223C4.122 27.593 4 10.096 4 9.303c0-.441.24-.848.627-1.062ZM16 27.999l.194.002c4.59 0 7.207-3.695 8.703-8.613 1.236-4.063 1.447-8.237 1.483-9.625l-10.186-5.65-.194.107v23.779Z"
})));
export default SvgShieldOutline;